import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface Props {
  className?: string;
  deviationCount: number;
  numSubscribers?: number;
}

export const FolderInfo: FC<Props> = ({
  className,
  deviationCount,
  numSubscribers,
}) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <span>
        {deviationCount} {t('common.deviations', { count: deviationCount })}
      </span>
      {numSubscribers !== undefined && (
        <span>
          {numSubscribers} {t('common.supporters', { count: numSubscribers })}
        </span>
      )}
    </div>
  );
};
FolderInfo.displayName = 'FolderInfo';

export default FolderInfo;
